import { gql } from "@apollo/client";


export const HSC_PROPERTIES_COUNT = gql`
query hscHotlistPropertiesCount($hscMemberMailId: String!) {
  hscHotlistPropertiesCount(hscMemberMailId: $hscMemberMailId){
    success
    message
    data{
      hsc_properties_count
    }
  }  
}
`

export const HSC_AGENTS_COUNT = gql`
query hscAgentsCount($hscMemberMailId: String!) {
  hscAgentsCount(hscMemberMailId: $hscMemberMailId){
		success
		message
		data{
			hsc_agents_count	
		}
	}
}
`

export const HSC_INVESTORS_COUNT = gql`
query hscInvestorsCount($hscMemberMailId: String!) {
  hscInvestorsCount(hscMemberMailId: $hscMemberMailId){
		success
		message
		data{
			hsc_investors_count
		}
	}
}
`

export const HSC_LENDER_COUNT = gql`
query hscLendersCount($hscMemberMailId: String!) {
  hscLendersCount(hscMemberMailId: $hscMemberMailId){
		success
		message
		data{
			hsc_lender_count
		}
	}
}
`

export const HSC_COURTING_COUNT = gql`
query hscCourtingCount($hscMemberMailId: String!) {
  hscCourtingCount(hscMemberMailId: $hscMemberMailId){
		success
		message
		data{
			hsc_courting_count
		}
	}
}
`

export const HSC_FOLLOW_UP_COUNT = gql`
query hscFollowupCount($hscMemberMailId: String!) {
  hscFollowupCount(hscMemberMailId: $hscMemberMailId){
		success
		message
		data{
			hsc_followup_count
		}
	}
}
`

export const HSC_HOTLIST_PROPERTIES = gql`
query hscHotlistProperties($hscMemberMailId: String!) {
  hscHotlistProperties(hscMemberMailId: $hscMemberMailId){
		success
		message
		data{
			arcimedes_row_id
			name
			status
			address
			city
			state
			list_price
			hsc_status
			source
			last_modified_date
		}
	}
}
`

export const HSC_HOTLIST_AGENTS = gql`
query hscHotlistAgents($hscMemberMailId: String!) {
  hscHotlistAgents(hscMemberMailId: $hscMemberMailId){
		success
		message
		data{
			arcimedes_row_id
			first_name
			last_name
			email
			cell_phone
			firm
			contact_id
		}
	}
}
`

export const HSC_HOTLIST_INVESTORS = gql`
query hscHotlistInvestors($hscMemberMailId: String!) {
  hscHotlistInvestors(hscMemberMailId: $hscMemberMailId){
		success
		message
		data{
			arcimedes_row_id
			first_name
			last_name
			email
			phone
			cell_phone
			company_name
			contact_id
			contact_type
			hsc_arcimedes_row_id
			hsc_contact_id
			hsc_id
		}
	}
}
`
export const HSC_HOTLIST_LENDERS = gql`
query hscHotlistLenders($hscMemberMailId: String!) {
  hscHotlistLenders(hscMemberMailId: $hscMemberMailId){
		success
		message
		data{
			arcimedes_row_id
			first_name
			last_name
			email
			phone
			cell_phone
			company_name
			contact_id
			contact_type
			hsc_arcimedes_row_id
			hsc_contact_id
			hsc_id
		}
	}
}
`

export const HSC_HOTLIST_COURTING = gql`
query hscHotlistCourting($hscMemberMailId: String!) {
  hscHotlistCourting(hscMemberMailId: $hscMemberMailId){
		success
		message
		data{
			arcimedes_row_id
			name
			status
			address
			city
			state
			list_price
			hsc_status
			source
			last_modified_date
		}
	}
}
`

export const HSC_HOTLIST_FOLLOW_UP = gql`
query hscHotlistFollowup($hscMemberMailId: String!) {
  hscHotlistFollowup(hscMemberMailId: $hscMemberMailId){
		success
		message
		data{
			arcimedes_row_id
			name
			status
			address
			city
			state
			list_price
			hsc_status
			source
			last_modified_date
		}
	}
}
`